export const F = {
  heading:  "'Montserrat', sans-serif",
  body:     "'Lato', sans-serif",
  display:  "'Bebas Neue', sans-serif",
  serif:    "'Playfair Display', serif",
};
